
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { mi, afd_create_campaign_icon, afd_donation_icon, afd_home_bg_banner, afd_my_record_icon } from "../../imgs";
import { useEffect, useRef, useState } from "react";
import { MyColor } from "../../config/myStyle";
import { authStore, campaignStore } from "../../stores";
import PageBox from "../../layout/PageBox";
import HomeCampaignItem from "./HomeCampaignItem";
import { useTranslation } from "react-i18next";

const Home = observer(() => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    campaignStore.getCampaignList({ limit: 3000 })
  }, [])

  const campaignList = campaignStore.campaignList
  const campaignRail = useRef<HTMLDivElement>(null);
  const [railState, setRailState] = useState({ left: false, right: false });
  // 根据实际滚动宽度更新按钮状态，活动数超过三项也能继续浏览。
  const updateRail = () => {
    const rail = campaignRail.current;
    if (rail) setRailState({ left: rail.scrollLeft > 1, right: rail.scrollLeft + rail.clientWidth < rail.scrollWidth - 2 });
  };
  useEffect(() => {
    const rail = campaignRail.current;
    if (!rail) return;
    const resize = new ResizeObserver(updateRail);
    resize.observe(rail);
    updateRail();
    return () => resize.disconnect();
  }, [campaignList.length]);
  const scrollCampaigns = (direction: number) => {
    const rail = campaignRail.current;
    rail?.scrollBy({ left: direction * Math.max(274, rail.clientWidth - 36), behavior: 'smooth' });
  };

  return (
    <PageBox spinning={campaignStore.campaignListStatus.loading}>
      <div className="w-full pb-[12px]" style={{ background: "#F9F8F0" }}>
        {/* 16:9 原相与左下角标语共用一个容器，文字独立翻译，不再充当下方简介的标题。 */}
        <div className="pt-[6px]">
          <div className="home-banner-frame w-full overflow-hidden">
            <img src={afd_home_bg_banner} alt={t("home.banner_alt")} width={850} height={1058} className="home-banner block w-full h-full object-cover" />
            <h1 lang={i18n.resolvedLanguage} className="home-banner-slogan">{t("home.banner_slogan")}</h1>
          </div>
        </div>
        <div className="px-[24px] pt-[18px] text-center text-[#6A6A6A]">
          <p className="mx-auto max-w-[680px] text-[16px] leading-[1.8]">{t("home.home_intro")}</p>
        </div>

        <div className="grid grid-cols-2 gap-[14px] px-[18px] pt-[18px]">
          {(authStore.loggedIn
            ? [
                {
                  icon: afd_my_record_icon,
                  label: t("home.your_record"),
                  action: () => navigate("/my-record"),
                },
                {
                  icon: afd_create_campaign_icon,
                  label: t("home.create_campaign"),
                  action: () => navigate("/campaign/create"),
                },
              ]
            : [
                {
                  icon: afd_donation_icon,
                  label: t("home.guest_support_donation"),
                  action: () => navigate("/donation"),
                },
                {
                  icon: afd_create_campaign_icon,
                  label: t("home.guest_create_fundraising_page"),
                  action: () => navigate("/register/form-a"),
                },
              ]).map((item, index) => (
            <button
              key={index}
              className="flex flex-col items-center justify-center rounded-[24px] border-[5px] border-[#C8A16C] bg-[white] px-[12px] py-[16px] text-center"
              style={{ minHeight: 164 }}
              onClick={item.action}
            >
              <img src={item.icon} alt="" className="h-[82px] w-[112px] object-contain" />
              <div
                className="mt-[10px] text-[18px] font-[700] leading-[1.22]"
                style={{ color: MyColor.blue }}
                dangerouslySetInnerHTML={{ __html: item.label }}
              />
            </button>
          ))}
        </div>

        <div className="px-[18px] pt-[18px]">
          <div className="rounded-[20px] bg-[#E71F76] px-[18px] py-[18px] text-center text-[white]">
            <div className="text-[16px] font-[700] leading-[1.35]">
              {t("home.current_foodangel_fundraising_projects")}
            </div>
          </div>
        </div>

        {/* 明确的左右按钮配合原生横向滚动，兼容鼠标、键盘和触屏。 */}
        {campaignList.length ? (
          <section aria-label={t("home.current_foodangel_fundraising_projects")}>
            <div className="flex justify-end gap-[12px] px-[18px] pt-[12px]">
              <button aria-label={t("home.previous_campaigns")} disabled={!railState.left} onClick={() => scrollCampaigns(-1)} className="campaign-arrow">←</button>
              <button aria-label={t("home.next_campaigns")} disabled={!railState.right} onClick={() => scrollCampaigns(1)} className="campaign-arrow">→</button>
            </div>
            <div ref={campaignRail} onScroll={updateRail} tabIndex={0} aria-label={t("home.campaign_list")} className="flex w-full gap-[14px] overflow-x-auto px-[18px] pb-[10px] pt-[14px]">
              {campaignList.map(campaign => <HomeCampaignItem key={campaign.id} campaign={campaign} onClick={id => navigate(`/campaign/${id}`)} />)}
            </div>
          </section>
        ) : <p className="px-[24px] py-[24px] text-center">{t("home.no_campaigns")}</p>}

        <div className="px-[18px] pb-[0px] pt-[10px]">
          <button
            className="flex h-[74px] w-full items-center justify-center rounded-[24px] bg-[#CBA77A] px-[24px] text-[white]"
            onClick={() => window.open("https://www.foodangel.org.hk/zh-hk/about-us", "_blank", "noopener,noreferrer")}
          >
            <img src={mi} alt="" className="mr-[14px] h-[62px] w-auto object-contain" />
            <span className="text-[18px] font-[700]">{t("home.about_us")}</span>
          </button>
        </div>

      </div>
    </PageBox>
  );
});

export default Home;
